// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.row h4 {
  margin-top: 5px;
}


.form-control {
  width: 100%; /* Largura total */
  padding: 8px; /* Espaçamento interno */
  border: 1px solid #ced4da; /* Borda cinza clara */
  border-radius: 4px; /* Bordas arredondadas */
  font-size: 14px; /* Tamanho da fonte */
}

.section-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}


.form-row {
  display: flex; /* Layout em linha */
  flex-wrap: wrap; /* Permite quebra de linha */
}

.form-group {
  margin-bottom: 20px; /* Espaço inferior */
  width: 100%; /* Largura total */
}

.list-search {
  list-style: none; /* Remove marcadores da lista */
  padding: 0; /* Remove padding padrão */
  margin: 0; /* Remove margem padrão */
  max-height: 300px; /* Altura máxima */
  overflow-y: auto; /* Ativa rolagem vertical */
  border: 1px solid #dee2e6; /* Borda cinza claro */
  border-radius: 4px; /* Bordas arredondadas */
}

.item-search {
  display: flex; /* Alinhamento horizontal */
  padding: 10px; /* Espaçamento interno */
  align-items: center; /* Alinhamento vertical central */
  border-bottom: 1px solid #dee2e6; /* Linha de divisão */
  transition: background-color 0.3s; /* Transição suave */
}

.item-search:last-child {
  border-bottom: none; /* Remove a borda do último item */
}

.item-search:hover {
  background-color: #f8f9fa; /* Fundo cinza claro no hover */
}

.item-search p {
  margin: 0; /* Remove margens padrão */
  font-size: 14px; /* Tamanho da fonte */
  color: #495057; /* Texto cinza médio */
}

.my-header-partner {
  display: flex; /* Flexbox para alinhar os itens lado a lado */
  align-items: center; /* Alinha verticalmente os itens ao centro */
}

.my-header-partner h1 {
  margin-right: 10px; /* Espaço entre o 'h1' e o 'label' */
}

.my-header-partner label {
  font-weight: bold; /* Você pode estilizar o 'label' conforme preferir */
  color: #6c757d; /* Cor cinza médio */
}

/* Estilo para a sobreposição (fundo preto) */



























/* Estilo para a sobreposição do modal */
.my-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7); /* Fundo preto com opacidade */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000; /* Coloca o modal acima de outros elementos */
}
.my-procedimento-item-p0{
  display: flex;
  align-items: center;
}
/* Estilo para o nome do procedimento */
.my-procedimento-item-p1 {
  display: inline-block;
  max-width: 300px; /* Definir um tamanho fixo */
  min-width: 300px; /* Definir um tamanho fixo */
  white-space: nowrap; /* Impedir quebra de linha */
  overflow: hidden; /* Esconde o texto que ultrapassa o limite */
  text-overflow: ellipsis; /* Exibe "..." se o texto ultrapassar o limite */
  cursor: pointer; /* Para indicar que pode ser interativo */
}
.my-procedimento-item-p2 {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;
  white-space: nowrap; /* Impedir quebra de linha */
  cursor: pointer; /* Para indicar que pode ser interativo */
}
.my-procedimento-item-p2 input{
  border: 1px solid #ced4da;
  border-radius: 30px;
  padding: 10px;
}
.my-procedimento-item-p3{
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;
}
.my-procedimento-item-p3-precos{
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  width: 100%;
}
.my-procedimento-item-p3-precos span{
  font-size: 13px;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  color: #acacac;
  background-color: #ffffff;
  border-radius: 30px;
  padding: 10px;
  border: 1px solid #ced4da;
}
.my-procedimento-item-p2-edit{
  cursor: pointer;
}
.my-procedimento-item-p2-excluir{
  cursor: pointer;
}
.my-procedimento-item-p2-edit img:hover, .my-procedimento-item-p2-excluir img:hover{
  scale: 1.1;
}


/* Exibir o nome completo ao passar o mouse */
.my-procedimento-item-p1:hover {
  text-overflow: clip; /* Remove a ellipsis quando o mouse passar */
  white-space: normal; /* Permite quebra de linha quando o mouse passar */
}

/* Exibir o nome completo ao passar o mouse */
.my-procedimento-item-p1[title]:hover {
  text-overflow: clip;
  white-space: normal;
}



/* Estilo para o conteúdo do modal */
.my-modal {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 70%; /* Máxima largura de 90% da tela */
  min-width: 300px; /* Largura mínima para evitar deformação */
  max-height: 75vh;
  min-height: 75vh;
  width: 100%;
  height: auto; /* Altura automática, mas com limites máximos e mínimos */
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin: 0 10px; /* Espaçamento nas laterais */
}

/* Estilo do cabeçalho fixo */
.my-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f4f4f4;
  padding: 10px 20px;
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid #ddd;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Estilo para o corpo do modal */
.my-modal-body {
  justify-content: flex-start;
  overflow-y: auto;
  padding: 20px;
  max-height: calc(100% - 80px); /* Ajuste da altura para acomodar o cabeçalho fixo */
}
/* Estilo específico para a lista de procedimentos */
.procedimentos-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

/* Estilo para o item de cada procedimento */
.procedimento-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  transition: background-color 0.3s ease;
  width: 100%; /* Garante que o item ocupe toda a largura disponível */
}

.procedimento-item:hover {
  background-color: #f0f0f0;
}
.modal-header-close{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.my-modal-header-switch{
  display: flex;
  justify-content: space-between;
  height: 90px;
  flex-direction: column;
  align-content: flex-end;
  align-items: flex-end;
}

div.my-modal-header-p1{
  display: flex;
  flex-direction: column;
}
.my-modal-header-p1 input{
border: 1px solid #ccc;
padding: 5px 15px;
border-radius: 10px 0px 0px 10px;
}
.my-modal-header-p1 button{
  border: 1px solid #ccc;
  padding: 5px 15px;
  border-radius: 10px;
  background-color: #b4b4b4;
  color: white;
}
.my-modal-footer{
  padding-top: 10px;
}
.my-modal-footer button{
border: none;
background-color: steelblue;
padding: 10px 15px;
border-radius: 35px;
color: white;
}
.my-modal-button{
  margin: 20px 20px 20px 0px;
border: none;
background-color: steelblue;
padding: 10px 15px;
border-radius: 35px;
color: white;
}
.my-modal-button-prof{
margin: 20px 20px 20px 0px;
border: none;
background-color: steelblue;
padding: 10px 15px;
border-radius: 35px;
color: white;
}

.my-modal-button-close{
border: none;
background-color: red;
padding: 5px 10px;
border-radius: 35px;
color: white;
}


.procedimento-checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.procedimento-checkbox input[type="checkbox"] {
  margin-right: 10px;
}

.procedimento-pricing {
  display: flex;
  flex-direction: column; /* Coloca os inputs um abaixo do outro */
  gap: 10px;
}

.procedimento-pricing input[type="text"] {
  width: 100%; /* Tamanho total do input */
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.procedimento-checkbox-delete {
  padding: 6px 12px;
  font-size: 14px;
  color: white;
  background-color: #e74c3c;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.procedimento-checkbox-delete:hover {
  background-color: #c0392b;
}

/* Adicionar media queries para telas pequenas */
@media (max-width: 600px) {
  .my-modal {
    max-width: 95%; /* Ajuste a largura para telas pequenas */
    padding: 15px; /* Reduz o padding */
    min-width: 270px; /* Ajuste para telas muito pequenas */
  }

  .my-modal-header h2 {
    font-size: 16px; /* Ajuste o tamanho da fonte */
  }

  .my-modal-header input[type="text"] {
    width: 100%; /* Faz a caixa de pesquisa ocupar toda a largura */
  }

  .procedimento-item {
    padding: 10px; /* Reduz o padding */
  }

  .procedimento-pricing input[type="text"] {
    width: 100%; /* Garante que os inputs ocupem toda a largura disponível */
  }
}


/*Na vertical*/
@media (max-width: 667px) {

}
`, "",{"version":3,"sources":["webpack://./src/views/partners/Partners.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;;AAGA;EACE,WAAW,EAAE,kBAAkB;EAC/B,YAAY,EAAE,wBAAwB;EACtC,yBAAyB,EAAE,sBAAsB;EACjD,kBAAkB,EAAE,wBAAwB;EAC5C,eAAe,EAAE,qBAAqB;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;;AAGA;EACE,aAAa,EAAE,oBAAoB;EACnC,eAAe,EAAE,4BAA4B;AAC/C;;AAEA;EACE,mBAAmB,EAAE,oBAAoB;EACzC,WAAW,EAAE,kBAAkB;AACjC;;AAEA;EACE,gBAAgB,EAAE,+BAA+B;EACjD,UAAU,EAAE,0BAA0B;EACtC,SAAS,EAAE,yBAAyB;EACpC,iBAAiB,EAAE,kBAAkB;EACrC,gBAAgB,EAAE,2BAA2B;EAC7C,yBAAyB,EAAE,sBAAsB;EACjD,kBAAkB,EAAE,wBAAwB;AAC9C;;AAEA;EACE,aAAa,EAAE,2BAA2B;EAC1C,aAAa,EAAE,wBAAwB;EACvC,mBAAmB,EAAE,iCAAiC;EACtD,gCAAgC,EAAE,qBAAqB;EACvD,iCAAiC,EAAE,oBAAoB;AACzD;;AAEA;EACE,mBAAmB,EAAE,kCAAkC;AACzD;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,SAAS,EAAE,0BAA0B;EACrC,eAAe,EAAE,qBAAqB;EACtC,cAAc,EAAE,sBAAsB;AACxC;;AAEA;EACE,aAAa,EAAE,8CAA8C;EAC7D,mBAAmB,EAAE,4CAA4C;AACnE;;AAEA;EACE,kBAAkB,EAAE,oCAAoC;AAC1D;;AAEA;EACE,iBAAiB,EAAE,oDAAoD;EACvE,cAAc,EAAE,oBAAoB;AACtC;;AAEA,6CAA6C;;;;;;;;;;;;;;;;;;;;;;;;;;;;AA4B7C,wCAAwC;AACxC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC,EAAE,8BAA8B;EACpE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc,EAAE,6CAA6C;AAC/D;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,gBAAgB,EAAE,4BAA4B;EAC9C,gBAAgB,EAAE,4BAA4B;EAC9C,mBAAmB,EAAE,4BAA4B;EACjD,gBAAgB,EAAE,4CAA4C;EAC9D,uBAAuB,EAAE,gDAAgD;EACzE,eAAe,EAAE,yCAAyC;AAC5D;AACA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,WAAW;EACX,mBAAmB,EAAE,4BAA4B;EACjD,eAAe,EAAE,yCAAyC;AAC5D;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;;;AAGA,6CAA6C;AAC7C;EACE,mBAAmB,EAAE,4CAA4C;EACjE,mBAAmB,EAAE,kDAAkD;AACzE;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;;;AAIA,oCAAoC;AACpC;EACE,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,cAAc,EAAE,kCAAkC;EAClD,gBAAgB,EAAE,0CAA0C;EAC5D,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY,EAAE,yDAAyD;EACvE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,cAAc,EAAE,6BAA6B;AAC/C;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA,iCAAiC;AACjC;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,6BAA6B,EAAE,oDAAoD;AACrF;AACA,oDAAoD;AACpD;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,WAAW,EAAE,uDAAuD;AACtE;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;AACA,sBAAsB;AACtB,iBAAiB;AACjB,gCAAgC;AAChC;AACA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;AACA,YAAY;AACZ,2BAA2B;AAC3B,kBAAkB;AAClB,mBAAmB;AACnB,YAAY;AACZ;AACA;EACE,0BAA0B;AAC5B,YAAY;AACZ,2BAA2B;AAC3B,kBAAkB;AAClB,mBAAmB;AACnB,YAAY;AACZ;AACA;AACA,0BAA0B;AAC1B,YAAY;AACZ,2BAA2B;AAC3B,kBAAkB;AAClB,mBAAmB;AACnB,YAAY;AACZ;;AAEA;AACA,YAAY;AACZ,qBAAqB;AACrB,iBAAiB;AACjB,mBAAmB;AACnB,YAAY;AACZ;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,wCAAwC;EAChE,SAAS;AACX;;AAEA;EACE,WAAW,EAAE,2BAA2B;EACxC,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gDAAgD;AAChD;EACE;IACE,cAAc,EAAE,yCAAyC;IACzD,aAAa,EAAE,oBAAoB;IACnC,gBAAgB,EAAE,qCAAqC;EACzD;;EAEA;IACE,eAAe,EAAE,8BAA8B;EACjD;;EAEA;IACE,WAAW,EAAE,kDAAkD;EACjE;;EAEA;IACE,aAAa,EAAE,oBAAoB;EACrC;;EAEA;IACE,WAAW,EAAE,2DAA2D;EAC1E;AACF;;;AAGA,cAAc;AACd;;AAEA","sourcesContent":[".row h4 {\n  margin-top: 5px;\n}\n\n\n.form-control {\n  width: 100%; /* Largura total */\n  padding: 8px; /* Espaçamento interno */\n  border: 1px solid #ced4da; /* Borda cinza clara */\n  border-radius: 4px; /* Bordas arredondadas */\n  font-size: 14px; /* Tamanho da fonte */\n}\n\n.section-header{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n}\n\n\n.form-row {\n  display: flex; /* Layout em linha */\n  flex-wrap: wrap; /* Permite quebra de linha */\n}\n\n.form-group {\n  margin-bottom: 20px; /* Espaço inferior */\n  width: 100%; /* Largura total */\n}\n\n.list-search {\n  list-style: none; /* Remove marcadores da lista */\n  padding: 0; /* Remove padding padrão */\n  margin: 0; /* Remove margem padrão */\n  max-height: 300px; /* Altura máxima */\n  overflow-y: auto; /* Ativa rolagem vertical */\n  border: 1px solid #dee2e6; /* Borda cinza claro */\n  border-radius: 4px; /* Bordas arredondadas */\n}\n\n.item-search {\n  display: flex; /* Alinhamento horizontal */\n  padding: 10px; /* Espaçamento interno */\n  align-items: center; /* Alinhamento vertical central */\n  border-bottom: 1px solid #dee2e6; /* Linha de divisão */\n  transition: background-color 0.3s; /* Transição suave */\n}\n\n.item-search:last-child {\n  border-bottom: none; /* Remove a borda do último item */\n}\n\n.item-search:hover {\n  background-color: #f8f9fa; /* Fundo cinza claro no hover */\n}\n\n.item-search p {\n  margin: 0; /* Remove margens padrão */\n  font-size: 14px; /* Tamanho da fonte */\n  color: #495057; /* Texto cinza médio */\n}\n\n.my-header-partner {\n  display: flex; /* Flexbox para alinhar os itens lado a lado */\n  align-items: center; /* Alinha verticalmente os itens ao centro */\n}\n\n.my-header-partner h1 {\n  margin-right: 10px; /* Espaço entre o 'h1' e o 'label' */\n}\n\n.my-header-partner label {\n  font-weight: bold; /* Você pode estilizar o 'label' conforme preferir */\n  color: #6c757d; /* Cor cinza médio */\n}\n\n/* Estilo para a sobreposição (fundo preto) */\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Estilo para a sobreposição do modal */\n.my-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7); /* Fundo preto com opacidade */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000; /* Coloca o modal acima de outros elementos */\n}\n.my-procedimento-item-p0{\n  display: flex;\n  align-items: center;\n}\n/* Estilo para o nome do procedimento */\n.my-procedimento-item-p1 {\n  display: inline-block;\n  max-width: 300px; /* Definir um tamanho fixo */\n  min-width: 300px; /* Definir um tamanho fixo */\n  white-space: nowrap; /* Impedir quebra de linha */\n  overflow: hidden; /* Esconde o texto que ultrapassa o limite */\n  text-overflow: ellipsis; /* Exibe \"...\" se o texto ultrapassar o limite */\n  cursor: pointer; /* Para indicar que pode ser interativo */\n}\n.my-procedimento-item-p2 {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  width: 100%;\n  white-space: nowrap; /* Impedir quebra de linha */\n  cursor: pointer; /* Para indicar que pode ser interativo */\n}\n.my-procedimento-item-p2 input{\n  border: 1px solid #ced4da;\n  border-radius: 30px;\n  padding: 10px;\n}\n.my-procedimento-item-p3{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: flex-end;\n  width: 100%;\n}\n.my-procedimento-item-p3-precos{\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  width: 100%;\n}\n.my-procedimento-item-p3-precos span{\n  font-size: 13px;\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  color: #acacac;\n  background-color: #ffffff;\n  border-radius: 30px;\n  padding: 10px;\n  border: 1px solid #ced4da;\n}\n.my-procedimento-item-p2-edit{\n  cursor: pointer;\n}\n.my-procedimento-item-p2-excluir{\n  cursor: pointer;\n}\n.my-procedimento-item-p2-edit img:hover, .my-procedimento-item-p2-excluir img:hover{\n  scale: 1.1;\n}\n\n\n/* Exibir o nome completo ao passar o mouse */\n.my-procedimento-item-p1:hover {\n  text-overflow: clip; /* Remove a ellipsis quando o mouse passar */\n  white-space: normal; /* Permite quebra de linha quando o mouse passar */\n}\n\n/* Exibir o nome completo ao passar o mouse */\n.my-procedimento-item-p1[title]:hover {\n  text-overflow: clip;\n  white-space: normal;\n}\n\n\n\n/* Estilo para o conteúdo do modal */\n.my-modal {\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  max-width: 70%; /* Máxima largura de 90% da tela */\n  min-width: 300px; /* Largura mínima para evitar deformação */\n  max-height: 75vh;\n  min-height: 75vh;\n  width: 100%;\n  height: auto; /* Altura automática, mas com limites máximos e mínimos */\n  overflow: hidden;\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  margin: 0 10px; /* Espaçamento nas laterais */\n}\n\n/* Estilo do cabeçalho fixo */\n.my-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #f4f4f4;\n  padding: 10px 20px;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  border-bottom: 1px solid #ddd;\n  background-color: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Estilo para o corpo do modal */\n.my-modal-body {\n  justify-content: flex-start;\n  overflow-y: auto;\n  padding: 20px;\n  max-height: calc(100% - 80px); /* Ajuste da altura para acomodar o cabeçalho fixo */\n}\n/* Estilo específico para a lista de procedimentos */\n.procedimentos-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* Estilo para o item de cada procedimento */\n.procedimento-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  padding: 15px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n  transition: background-color 0.3s ease;\n  width: 100%; /* Garante que o item ocupe toda a largura disponível */\n}\n\n.procedimento-item:hover {\n  background-color: #f0f0f0;\n}\n.modal-header-close{\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n.my-modal-header-switch{\n  display: flex;\n  justify-content: space-between;\n  height: 90px;\n  flex-direction: column;\n  align-content: flex-end;\n  align-items: flex-end;\n}\n\ndiv.my-modal-header-p1{\n  display: flex;\n  flex-direction: column;\n}\n.my-modal-header-p1 input{\nborder: 1px solid #ccc;\npadding: 5px 15px;\nborder-radius: 10px 0px 0px 10px;\n}\n.my-modal-header-p1 button{\n  border: 1px solid #ccc;\n  padding: 5px 15px;\n  border-radius: 10px;\n  background-color: #b4b4b4;\n  color: white;\n}\n.my-modal-footer{\n  padding-top: 10px;\n}\n.my-modal-footer button{\nborder: none;\nbackground-color: steelblue;\npadding: 10px 15px;\nborder-radius: 35px;\ncolor: white;\n}\n.my-modal-button{\n  margin: 20px 20px 20px 0px;\nborder: none;\nbackground-color: steelblue;\npadding: 10px 15px;\nborder-radius: 35px;\ncolor: white;\n}\n.my-modal-button-prof{\nmargin: 20px 20px 20px 0px;\nborder: none;\nbackground-color: steelblue;\npadding: 10px 15px;\nborder-radius: 35px;\ncolor: white;\n}\n\n.my-modal-button-close{\nborder: none;\nbackground-color: red;\npadding: 5px 10px;\nborder-radius: 35px;\ncolor: white;\n}\n\n\n.procedimento-checkbox {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.procedimento-checkbox input[type=\"checkbox\"] {\n  margin-right: 10px;\n}\n\n.procedimento-pricing {\n  display: flex;\n  flex-direction: column; /* Coloca os inputs um abaixo do outro */\n  gap: 10px;\n}\n\n.procedimento-pricing input[type=\"text\"] {\n  width: 100%; /* Tamanho total do input */\n  padding: 8px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.procedimento-checkbox-delete {\n  padding: 6px 12px;\n  font-size: 14px;\n  color: white;\n  background-color: #e74c3c;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.procedimento-checkbox-delete:hover {\n  background-color: #c0392b;\n}\n\n/* Adicionar media queries para telas pequenas */\n@media (max-width: 600px) {\n  .my-modal {\n    max-width: 95%; /* Ajuste a largura para telas pequenas */\n    padding: 15px; /* Reduz o padding */\n    min-width: 270px; /* Ajuste para telas muito pequenas */\n  }\n\n  .my-modal-header h2 {\n    font-size: 16px; /* Ajuste o tamanho da fonte */\n  }\n\n  .my-modal-header input[type=\"text\"] {\n    width: 100%; /* Faz a caixa de pesquisa ocupar toda a largura */\n  }\n\n  .procedimento-item {\n    padding: 10px; /* Reduz o padding */\n  }\n\n  .procedimento-pricing input[type=\"text\"] {\n    width: 100%; /* Garante que os inputs ocupem toda a largura disponível */\n  }\n}\n\n\n/*Na vertical*/\n@media (max-width: 667px) {\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
